/**
 * Nombres convencionales de los rangos día/mes/año y sus etiquetas en la barra
 * de filtros globales. El nombre técnico del parámetro no se cambia: ya está
 * en el SQL publicado.
 */

/** Nombres de parámetro convencionales de los rangos día/mes/año. */
export const MONTH_YEAR_PRESET_PARAMS = {
  dayDesde: 'diaDesde',
  dayHasta: 'diaHasta',
  monthDesde: 'mesDesde',
  monthHasta: 'mesHasta',
  yearDesde: 'anoDesde',
  yearHasta: 'anoHasta',
};

const MONTH_YEAR_PRESET_PARAM_LABELS = {
  [MONTH_YEAR_PRESET_PARAMS.dayDesde]: 'Fecha desde',
  [MONTH_YEAR_PRESET_PARAMS.dayHasta]: 'Fecha hasta',
  [MONTH_YEAR_PRESET_PARAMS.monthDesde]: 'Mes desde',
  [MONTH_YEAR_PRESET_PARAMS.monthHasta]: 'Mes hasta',
  [MONTH_YEAR_PRESET_PARAMS.yearDesde]: 'Año desde',
  [MONTH_YEAR_PRESET_PARAMS.yearHasta]: 'Año hasta',
};

/** Etiqueta amigable para uno de esos parámetros, o null si no es uno de los 6. */
export function monthYearPresetParamLabel(paramName) {
  return MONTH_YEAR_PRESET_PARAM_LABELS[String(paramName || '').trim()] || null;
}
